import { usePlanRepository } from '@hotjar/webapp/hooks/usePlanRepository';
import { useAccountTrialInfo } from '@hotjar/account';
import type { Site } from '@hotjar/site';
import { BASIC, PLUS, BUSINESS, SCALE } from '@hotjar/webapp/domains/revenue/plan/feature-group';
import { BasicPlanDetails } from './BasicPlanDetails';
import { PlusPlanDetails } from './PlusPlanDetails';
import { BusinessPlanDetails } from './BusinessPlanDetails';
import { ScalePlanDetails } from './ScalePlanDetails';

interface PlanDetailsProps {
  site: Site;
}

export function PlanDetails({ site }: PlanDetailsProps): JSX.Element | null {
  const { effectivePlan: plan, effectivePlanId } = site;
  const { active: inTrial = false, daysRemaining: daysRemainingRaw = 0 } =
    useAccountTrialInfo() ?? {};
  const daysRemaining = daysRemainingRaw ? Math.round(daysRemainingRaw) : 0;
  const planRepository = usePlanRepository();
  const hasCC = site ? planRepository.byId(effectivePlanId).ccDailyAllowance > 0 : false;

  switch (plan) {
    case SCALE:
      return <ScalePlanDetails />;
    case BUSINESS:
      return <BusinessPlanDetails inTrial={inTrial} daysRemaining={daysRemaining} />;
    case PLUS:
      return <PlusPlanDetails inTrial={inTrial} daysRemaining={daysRemaining} />;
    case BASIC:
      return <BasicPlanDetails hasCC={hasCC} />;
    default:
      return null;
  }
}
